import React, {useContext, useEffect} from "react";
import {Navigate} from 'react-router-dom'
import { NavLink} from 'react-router-dom';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import ClientSubconFullRenderer from './ClientSubconFullRendererComponent';
import { RoleSubcontractor, SubcontractorService } from "../constants/Consts";
import BucketContext from "../context/BucketContext";
import * as Security from '../../utils/auth/Security';


function ClientSubconNew(props) {
    console.log('___Client Subcontractor New___');

    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        props.loadComponentData(props.client.id);
    }, [props.client]);


    const subcontractor = {
        generalSection: {
            subconForClientId: props.client.id,
            role: RoleSubcontractor.ClientSubcon,
            serviceType: SubcontractorService.RSVTI
        }
    }

    if(bucketContext.bucket.mostRecentClientSubconId != null) {
        return(
            <Navigate to={`/clients/subcon/${bucketContext.bucket.mostRecentClientSubconId}?clientId=${props.client.id}`} replace />
        );
    }
    else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            {Security.isUserAuthorizedForPath('/clients') ?
                                <NavLink to={`/clients/${props.client.id}`}>{props.client.generalSection.clientName}</NavLink>
                                    :
                                <NavLink to='/myclient'>{props.client.generalSection.clientName}</NavLink>
                            }
                            <Typography color="text.primary">Adauga Subcontractor</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <h3>Subcontractor Nou</h3>
                    </Box>
                    <hr/>
    
                    <ClientSubconFullRenderer 
                        subcontractor={subcontractor} 
                        saveSubcontractor={props.postSubcontractor} 
                        clients={props.clients}
                        employers={props.employers}
                        worksites={props.worksites}    
                    />
                </Stack>

            </Box>
            </Container>
        );
    }

}

export default ClientSubconNew;